import React, { useEffect, useState } from "react";
import { vapi } from "../../Talk/Talk";

const useCallFrontDesk = ({
  vapiAssistanceId,
  setIsLoading,
  showSuccessMessage,
}) => {
  const [isCallActive, setIsCallActive] = useState(false);
  const [isMuted, setIsMuted] = useState(vapi.isMuted());

  const startCall = async () => {
    setIsLoading(true);
    try {
      await vapi.start(vapiAssistanceId);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const toggleMute = () => {
    vapi.setMuted(!isMuted);
    setIsMuted(!isMuted);
  };

  const endCall = () => {
    vapi.stop();
    setIsCallActive(false);
  };

  useEffect(() => {
    vapi.on("call-start", () => setIsCallActive(true));
    vapi.on("call-end", () => {
      setIsCallActive(false);
      showSuccessMessage("Call ended successfully!");
    });
  }, []);

  useEffect(()=>{
    if (vapiAssistanceId) {
      return () => {
        vapi.stop();
      };
    }
  },[vapiAssistanceId])

  return {
    isCallActive,
    isMuted,
    startCall,
    toggleMute,
    endCall,
  };
};

export default useCallFrontDesk;
